import { isObject } from "lodash";

const migrations = {
  0: (state) => {
    const newState = state;

    // Remove unused Redux keys
    if (isObject(newState)) {
      delete newState["user"];
      delete newState["search"];
      delete newState["question"];
      delete newState["signup"];
    }
    return Promise.resolve(newState);
  },
  1: (state) => {
    const newState = state;

    // Reset 'shop' redux data due to changes
    // in how Shopify product data is stored and use.
    if (isObject(newState)) {
      delete newState["shop"];
    }
    return Promise.resolve(newState);
  },
};

export default migrations;
